import { Col, Container, Row } from "react-bootstrap";
import ContactCard from "../../components/contact/ContactCard";
import ContactForm from "../../components/forms/ContactForm";
import Location from "../../components/contact/Location";
import "./index.css";
import { Helmet } from "react-helmet-async";
import useAppData from "../../hooks/useAppData";

const Contact = () => {
	const { settings, contactPage } = useAppData();

	return (
		<>
			<Helmet>
				<title>{contactPage.meta_title}</title>
				<meta name="description" content={contactPage.meta_description} />
				<meta name="keywords" content={contactPage.meta_keywords} />
			</Helmet>
			<section>
				<div className="contact-page__banner">
					<img src="assets/images/banners/contact-us-banner.jpg" alt="" />
					<h2 className="text-uppercase">Get in touch with us Today</h2>
					<p>Home &nbsp; • &nbsp; Contact us</p>
				</div>
				<Container className="contact-page__content">
					<Row>
						<Col
							md={12}
							lg={6}
							sm={12}
							xs={12}
							className="contact-page__info d-flex justify-content-center align-items-center flex-column"
						>
							<Row className="w-100">
								<h2>
									<span>Connect</span> with us Today
									<br />
									and <span>we'll Help you</span>
								</h2>
							</Row>
							<Row className="g-1 justify-content-center">
								<Row className="g-4 p-0">
									<Col md={6} lg={6} sm={12} xs={12}>
										<ContactCard
											icon={"assets/icons/phone-call.png"}
											description={settings?.phone_number || "Not Available"}
											title={"Phone Number"}
											link={"tel:" + (settings?.phone_number || "")}
										/>
									</Col>
									<Col md={6} lg={6} sm={12} xs={12}>
										<ContactCard
											icon={"assets/icons/email.png"}
											description={settings?.email || "Not Available"}
											title={"Email Address"}
											link={"mailto:" + (settings?.email || "")}
										/>
									</Col>
								</Row>
								<Row className="g-4 p-0 mt-0">
									<Col md={6} lg={6} sm={12} xs={12}>
										<ContactCard
											icon={"assets/icons/location.png"}
											description={settings?.office_address || "Not Available"}
											title={"Address"}
											link={settings?.google_maps_link || "#"}
										/>
									</Col>
									<Col md={6} lg={6} sm={12} xs={12}>
										<ContactCard
											icon={"assets/icons/calendar.png"}
											description={"Saturday - Friday 10:00 am - 8:00 pm"}
											title={"Business Hours"}
										/>
									</Col>
								</Row>
							</Row>
						</Col>
						<Col
							md={12}
							lg={6}
							sm={12}
							xs={12}
							className="contact-page__form d-flex justify-content-center align-items-center flex-column"
						>
							<ContactForm />
						</Col>
					</Row>
				</Container>
				<div style={{ backgroundColor: "#5f5f60" }}>
					<Location google_maps_link={settings?.google_maps_link || ""} />
				</div>
			</section>
		</>
	);
};

export default Contact;
